import { SVGProps } from 'react';
export const ShareSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 448 512"
        {...props}
    >
        <path
            fill="currentColor"
            d="M241 7c-9.4-9.4-24.6-9.4-33.9 0L79 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87V328c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9l87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zM48 344c0-13.3-10.7-24-24-24S0 330.7 0 344v80c0 48.6 39.4 88 88 88h272c48.6 0 88-39.4 88-88v-80c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40v-80z"
        />
    </svg>
);

export const PhoneSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 512 512"
        {...props}
    >
        <path
            fill="currentColor"
            d="M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1l40.5-33.1c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6.9l-112 24C13.2 28.8 0 45.1 0 64c0 231.2 175.2 421.6 400.1 445.5 9.8 1 19.6 1.8 29.6 2.2h.1c6.1.2 12.1.4 18.2.4 18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM441.5 464c-215.7-3.5-390-177.8-393.4-393.5l99.2-21.3 43 100.4-35.9 29.4c-18.2 14.9-22.9 40.8-11.1 61.2 30.9 53.3 75.3 97.7 128.6 128.6 20.4 11.8 46.3 7.1 61.2-11.1l29.4-35.9 100.4 43-21.4 99.2zM48 64"
        />
    </svg>
);

export const EmailSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 512 512"
        {...props}
    >
        <path
            fill="currentColor"
            d="M64 112c-8.8 0-16 7.2-16 16v22.1l172.5 141.6c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
        />
    </svg>
);

export const ListSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 512 512"
        {...props}
    >
        <path
            fill="currentColor"
            d="M40 48c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zm144 24c-13.3 0-24 10.7-24 24s10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h304c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zM16 232v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zm24 136c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H40z"
        />
    </svg>
);

export const MapSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 576 512"
        {...props}
    >
        <path
            fill="currentColor"
            d="M565.6 36.2C572.1 40.7 576 48.1 576 56v336c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1.3l-183.9-61.2-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456V120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3l183.9 61.2 160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5v284.7l120-45.7V90.8L48 136.5zm312 286.2V137.3l-144-48v285.4l144 48zm48-1.5 120-45.7V90.8l-120 45.7v284.7z"
        />
    </svg>
);

export const Circle1SVG = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 512 512"
        {...props}
    >
        <path
            fill="currentColor"
            d="M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm268-124.8c-7.4-4.3-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9l20.2-11.3V336h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h128c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40V152c0-8.6-4.6-16.5-12-20.8z"
        />
    </svg>
);

export const Circle2SVG = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 512 512"
        {...props}
    >
        <path
            fill="currentColor"
            d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-33.3-327.3-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4.1c46.5.7 83.8 38.6 83.8 85.1 0 23.5-9.7 46-26.9 62.1L244.7 336H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3l108.7-101.9c7.5-7 11.7-16.8 11.7-27.1 0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3z"
        />
    </svg>
);

export const Circle3SVG = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 512 512"
        {...props}
    >
        <path
            fill="currentColor"
            d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384h128c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6 0 46.5-37.7 84.2-84.2 84.2H240c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2a38.75 38.75 0 0 0 33 18.4h27.8c20 0 36.2-16.2 36.2-36.2 0-20.1-16.3-36.3-36.4-36.2l-51.5.3c-9.9.1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5l50.7-46.2H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        />
    </svg>
);

export const Circle4SVG = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 512 512"
        {...props}
    >
        <path
            fill="currentColor"
            d="M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm223.6-126.8c-12.6-4.2-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10h104v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-56c0-13.3-10.7-24-24-24s-24 10.7-24 24v56h-70.7l37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4z"
        />
    </svg>
);

export const CirclePlusSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 512 512"
        {...props}
    >
        <path
            fill="currentColor"
            d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-24-168v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        />
    </svg>
);

export const WhiteCloseSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 384 512"
        {...props}
    >
        <path
            fill="white"
            d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5c-11.3-13.6-31.5-15.4-45.1-4.1S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306l135.4 162.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"
        />
    </svg>
);
